import { DocumentsTab } from './DocumentsTab';

interface LabsTabProps {
  patientId: string;
}

export function LabsTab({ patientId }: LabsTabProps) {
  return <DocumentsTab patientId={patientId} filterType="lab_result" />;
}
